import React, {Component, Fragment} from "react";
import {Link, withRouter} from "react-router-dom";
import ToastHelper from "../../../utils/ToastHelper";
import {Col, Row} from "reactstrap";
import TransactionCard from "../../../components/Transaction/TransactionCard";
import SFXLoadingComponent from "../../../components/SFXLoadingComponent";
import ButtonAddNewComponent from "../../../components/ButtonAddNewComponent";
import "./transaction.css";
import SFXButtonComponent from "../../../components/SFXButtonComponent";
import Card from "reactstrap/es/Card";
import UniversalTransactionService from "../../../services/Transaction/UniversalTransactionService";

class Transactions extends Component {
    constructor(props) {
        super(props);

        this.className = this.props.isMobile ? "mobile" : "browser";

        this.state = {
            transactionData: [],
            registrationId: '',
            loading: true,
            pageSize: 10,
            showLoadMore: true
        };

    }

    componentDidMount() {
        this.loadData();
        this.props.setHeader("Transactions");
        this.props.setSelectedScreen("Transactions");
    }

    loadData() {

        UniversalTransactionService.retrieveUniversalTransaction(this.props.customer.registrationId, this.state.pageSize).then(response => {
            let totalRecords = response.headers.get("X-Total-Records");
            if (response.body) {
                this.setState({
                    loading: false,
                    transactionData: response.body,
                    showLoadMore: totalRecords > response.body.length
                });
            } else {
                ToastHelper.formatError(response);
            }
        });
    }

    doRefresh() {
        this.loadData();
    }


    render() {

        if (this.state.loading) {
            return <SFXLoadingComponent/>
        }

        return <Fragment>

            {this.props.isMobile ? this.renderContent("mobile") : this.renderBrowserTransactionCards()}

        </Fragment>

    }

    renderContent(className) {

        return <Fragment>
            <div style={{
                width: "100%",
                height: "95%",
                overflowY: "scroll",
                overflowX: "hidden",
                padding: "10px",
                backgroundColor: "rgb(240, 240, 240)",
                margin: "auto"
            }}>
                <Row>
                    {this.state.transactionData.length === 0 ?
                        <Fragment>
                            <div style={{textAlign: "center", width: "100%"}}>
                                No Transactions Found
                            </div>
                        </Fragment>
                        :
                        <Fragment>
                            {this.state.transactionData.map((transaction, index) => {
                                return <Col sm={12} key={index}>
                                    <TransactionCard
                                        index={index}
                                        transactionData={transaction}
                                        isMobile={this.className}
                                        doRefresh={this.doRefresh.bind(this)}
                                    />
                                </Col>
                            })
                            }
                        </Fragment>
                    }

                    {this.state.showLoadMore &&
                    <div
                        style={{margin: "auto", marginBottom: "15px", textAlign: "center"}}
                    >
                        <SFXButtonComponent
                            className={className + "_orange_oval_button"}
                            onClick={() => this.setState({
                                pageSize: this.state.pageSize + 10
                            }, () => this.loadData())}
                        >
                            Load More
                        </SFXButtonComponent>
                    </div>
                    }

                    <ButtonAddNewComponent
                        className={this.className}
                        link={"/create-transaction"}
                        transactionNew={true}
                    />
                </Row>
            </div>
        </Fragment>
    }

    renderBrowserTransactionCards() {
        return <Fragment>
            <Card style={{
                padding: "15px",
                height: "75%",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                borderRadius: "15px",
                width: "85%",
                margin: "auto"
            }}>
                <div style={{
                    overflowY: "scroll",
                    overflowX: "hidden"
                }}
                     className={"browser-card"}
                >
                    {this.state.transactionData.length === 0 ?
                        <Fragment>
                            <div style={{height: "80%", textAlign: "center"}}>
                                <br/>
                                You have no transactions.
                                <br/>
                                Click below to create a transaction and start sending money now
                                <br/>
                                <br/>
                                <Link to={"/create-transaction"}>
                                    <SFXButtonComponent className={"browser_orange_oval_button"}>
                                        Send Money Now
                                    </SFXButtonComponent>
                                </Link>
                            </div>
                        </Fragment>
                        :
                        <Fragment>
                            <div>
                                {this.state.transactionData.map((transaction, index) => {
                                    return <Fragment key={index}>
                                        <Col sm={12}>
                                            <TransactionCard
                                                transactionData={transaction}
                                                isMobile={this.className}
                                                doRefresh={this.doRefresh.bind(this)}
                                            />
                                        </Col>
                                    </Fragment>
                                })
                                }
                            </div>
                        </Fragment>
                    }
                    {this.state.showLoadMore &&
                    <div
                        style={{margin: "auto", marginBottom: "15px", textAlign: "center"}}
                    >
                        <SFXButtonComponent
                            className={"browser_orange_oval_button"}
                            onClick={() => this.setState({
                                pageSize: this.state.pageSize + 10
                            }, () => this.loadData())}
                        >
                            Load More
                        </SFXButtonComponent>
                    </div>
                    }
                    <ButtonAddNewComponent
                        className={this.className}
                        link={"/create-transaction"}
                        transactionNew={true}
                    />
                </div>

            </Card>
        </Fragment>
    }
}

export default withRouter(Transactions);